import React from 'react'
import PropTypes from 'prop-types'
import { Button, HStack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function IconButton({ text, variant, color, icon, ...rest }) {
  return (
    <Button h="100%" w="100%" variant={variant || 'secondary'} {...rest}>
      <HStack>
        <FontAwesomeIcon size="lg" color={color} icon={icon} />
        <Text color={color} variant="rounded-button">
          {text}
        </Text>
      </HStack>
    </Button>
  )
}

IconButton.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.any,
  text: PropTypes.string,
  variant: PropTypes.string,
}

export default IconButton
